import { render, staticRenderFns } from "./RestaurantBanner.vue?vue&type=template&id=3c236ce8&lang=pug&"
import script from "./RestaurantBanner.vue?vue&type=script&lang=js&"
export * from "./RestaurantBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports